/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Freeze_Confirm_AccessInputs */



/**
* | output |
* | --- |
* | "Every member loses access immediately; nothing is deleted." |
*
* @param {Partner_Org_Freeze_Confirm_AccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_freeze_confirm_access = /** @type {((inputs?: Partner_Org_Freeze_Confirm_AccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Freeze_Confirm_AccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Mitglieder verlieren sofort den Zugriff; es wird nichts gelöscht.")
	return /** @type {LocalizedString} */ ("Every member loses access immediately; nothing is deleted.")
});